import React from 'react'
import { graphql, Link } from 'gatsby'
import SEO from '../components/seo'
import Img from 'gatsby-image'
import styled from 'styled-components'
import ClientPostNav from '../components/clientNav'

const PostSection = styled.div`
  margin: 2em 0;
  display: grid;
  grid-template-columns: auto 3fr 1fr;
  grid-gap: 3em;

  div:first-child {
    @media screen and (max-width: 800px) {
      order: 2;
    }
  }

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`

const ImageSection = styled.div`
  max-width: 700px;
  margin: 0 auto 2em auto;

  @media screen and (max-width: 800px) {
    margin: 0 0 2em 0;
    max-width: 100%;
  }
`

const Title = styled.h1`
  font-weight: normal;
  text-transform: uppercase;
  position: sticky;
  top: 103px;
  height: 36px;
  line-height: 1.4;

  @media screen and (max-width: 800px) {
    margin-bottom: 2em;
  }
`

const ArticlePage = ({ data }) => {
  const collection = data.prismicClient
  return (
    <>
      <SEO title={collection.data.title.text} image={collection.data.gallery[0].image.url} />
      <div>
        <PostSection>
          <div>
            <ClientPostNav />
          </div>

          <div>
            {collection.data.gallery.map(node => (
              <ImageSection key={node.id}>
                <Img
              fluid={node.image.localFile.childImageSharp.fluid}
            />
                {/* <Img fluid={image.fluid} key={image.id} alt={image.title} /> */}
              </ImageSection>
            ))}
          </div>
          <Title>
            <Link to="/work">Client</Link> / {collection.data.title.text}
          </Title>
        </PostSection>
      </div>
    </>
  )
}

export const query = graphql`
  query($id: String!) {
    prismicClient(id: { eq: $id }) {
      id
      data {
        title {
          text
        }
      gallery {
        image {
          url
          localFile {
            publicURL
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }

      

        # fluid(maxWidth: 910) {
        #   ...GatsbyDatoCmsFluid
        # }
      }
      }
    }
  }
`

export default ArticlePage
